import { render } from "./NavbarPC.vue?vue&type=template&id=1148c3e2"
import script from "./NavbarPC.vue?vue&type=script&lang=js"
export * from "./NavbarPC.vue?vue&type=script&lang=js"

import "./NavbarPC.vue?vue&type=style&index=0&id=1148c3e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__